import React from "react";

const ASP_include = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP include</h1>
      <p>This is the ASP include page content.</p>
    </div>
  );
};

export default ASP_include;
